module.exports = __webpack_public_path__ + "img/ranking_bg.c15916f1.png";